<template lang="pug">
.container.bills
  .ui.warning.message.hide-in-desktop
    .content
      .header 移动设备兼容性
      p 收支明细对移动设备兼容不佳，建议在电脑上进行操作。

  auto-edit-table(
    title='收支明细',
    :defines='$defines.bill',
    :data='filtered',
    :pagesize='20',
    ref='edittable',
    detail-view,
    summary,
    unstackable,
    sortable,
    :button-add='$permission.has("basic.create.bills")',
    :actions='actions',
    :page-reset-on-change='false',
    @action:print='select_bill',
    @action:print_select='cancel_bill',
    @action:mark_verified='mark_verified',
    @action:mark_review='mark_review',
    @action:mark_invalid='mark_invalid',
  )
    template(slot='afterTitle')
      balance-bar(:date='time_end' :state='select_state')

      filters-group(:data='bills', :result.sync='filtered', @update:states='i => filterState = i')
        .ui.two.columns.stackable.form.grid.filters
          .column
            h4 状态
            filter-select(:filter='$defines.bill.filters.state', :select.sync='select_state')
            h4 时间
            filter-date-range(:filter='$defines.bill.filters.date', :select.sync='select_time', :start.sync='time_start', :end.sync='time_end')
          .column
            h4 类型
            filter-select(:filter='$defines.bill.filters.types', :select.sync='select_type')
            h4 搜索
            filter-search(:filter='$defines.bill.filters.search', :defines='$defines.bill', placeholder='搜索...')


  .print-float(v-show='print_selected.length')
    .ui.icon.button.themed(@click='print()', @contextmenu.prevent='clear_select_bills()')
      i.icon.print.big
      br
      br
      p 打印
    .floating.ui.orange.label.small.circular {{print_selected.length}}

  el-dialog(title='选择打印格式', :visible.sync='dialog_printing', size='small', :before-close='printing_close')
    span.dialog-footer(slot='footer')
      .ui.button.blue(type='primary', @click='print_fee()') 补打收款收据
      .ui.button.orange(type='primary', @click='print_bills()') 打印财务账单
      .ui.button(@click='dialog_printing = false') 取消
</template>

<script>
import { Notification } from 'element-ui'
import { AutoEditTable } from '../components/auto'
import { FiltersGroup, FilterSearch, FilterSelect, FilterDateRange } from '../components/filters'
import { BalanceBar } from '../components/basic'

export default {
  name: 'bills',
  components: {
    AutoEditTable,
    FiltersGroup,
    FilterSearch,
    FilterSelect,
    FilterDateRange,
    BalanceBar,
  },
  data() {
    return {
      filtered: [],
      select_state: 'pending',
      select_time: 'today',
      select_type: null,
      time_start: null,
      time_end: null,
      print_selected: [],
      bills: [],
      dialog_printing: false,
      balance: {},
      filterState: {},
    }
  },
  mounted() {
    this.load_bills()
  },
  methods: {
    actions(record) {
      let actions = []
      if (record.state === 'pending')
        actions = ['mark_review', 'mark_invalid', 'edit']
      else if (record.state === 'review')
        actions = ['mark_verified', 'mark_invalid', 'edit']

      if (this.print_selected.includes(record))
        actions.push('print_select')
      else
        actions.push('print')

      return actions
    },
    load_bills() {
      this.$store.dispatch('load_subjectstree', this)

      this.$http.get('bills')
        .then(r => {
          this.bills = r.body
        })
        .catch((...args) => {
          this.$utils.DefaultErrorHandler.call(this, ...args)
        })
    },
    select_bill(bill) {
      if (!this.print_selected.includes(bill))
        this.print_selected.push(bill)
    },
    cancel_bill(bill) {
      if (this.print_selected.includes(bill)) {
        const index = this.print_selected.indexOf(bill)
        if (index > -1)
          this.print_selected.splice(index, 1)
      }
    },
    print() {
      this.dialog_printing = true
    },
    printing_close() {
      this.clear_select_bills()
    },
    print_fee() {
      if (!Array.isArray(this.print_selected))
        this.print_selected = [this.print_selected]

      this.$templater.request('other_fee', {
        $methods: this.$store.state.summary.payment_methods,
        fees: this.print_selected.map(b => ({
          room: (this.$store.getters.room_by_id(b._room) || {}).no,
          subject: [b.subject1, b.subject2, b.subject3].join('-'),
          detail: b.detail,
          note: b.note,
          quantity: b.quantity,
          money: (b.income_actual || 0) - (b.outcome_actual || 0),
          payment_method: b.payment_method,
        })),
      })
      this.dialog_printing = false

      this.clear_select_bills()
    },
    print_bills() {
      if (!Array.isArray(this.print_selected))
        this.print_selected = [this.print_selected]

      this.$templater.request('bills', {
        $methods: this.$store.state.summary.payment_methods,
        fees: this.print_selected.map(b => ({
          room: (this.$store.getters.room_by_id(b._room) || {}).no,
          subject: [b.subject1, b.subject2, b.subject3].join('-'),
          detail: b.detail,
          note: b.note,
          quantity: b.quantity,
          income: b.income_actual || 0,
          outcome: b.outcome_actual || 0,
          payment_method: b.payment_method,
        })),
      })
      this.dialog_printing = false

      this.clear_select_bills()
    },
    clear_select_bills() {
      this.print_selected = []
    },
    mark_verified(bill) {
      return this.mark_bill(bill, 'verified')
    },
    mark_review(bill) {
      return this.mark_bill(bill, 'review')
    },
    mark_invalid(bill) {
      return this.mark_bill(bill, 'invalid')
    },
    mark_bill(bill, state) {
      this.$http.put(`bills/${bill._id}/mark/${state}`)
        .then(r => {
          if (!r.body || r.body.error) {
            Notification({
              title: '操作失败',
              message: JSON.stringify(r.body.error, null, 2),
              type: 'error',
            })
          } else {
            Notification({
              title: '操作成功',
              type: 'success',
            })
            bill = Object.assign(bill, r.body)
          }
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
  },
}
</script>




// WEBPACK FOOTER //
// Bills.vue?76a28c84